import React from 'react';
import { FixAndFlipCalculation } from '../../lib/models/short-term/short-term-calculation.model';
import { RentalCalculation } from '../../lib/models/rental/rental-calculation.model';
import LoanCalculationsAndTerms from '../stf-quote/LoanCalculationsAndTerms';
import RentalScenarios from '../rental-quote/RentalScenarios';
import { CalculationType } from '../../state/quote-reducer';

export interface QuoteCalcInfoProps {
    isFnf: boolean;
    calculation: CalculationType;
    setPreferredLoanAmt: React.Dispatch<React.SetStateAction<number | undefined>> | undefined;
  }

const QuoteCalcInfo = (props: QuoteCalcInfoProps) => {
    return (
        <>
            {props.isFnf ? (
                <LoanCalculationsAndTerms
                    calculation={props.calculation as FixAndFlipCalculation}
                />
            ) : (
                <RentalScenarios
                    scenarios={
                    (props.calculation as RentalCalculation)?.scenarios || []
                    }
                    setPreferredLoanAmt={props.setPreferredLoanAmt}
                />
            )}
        </>
    )
}

export default QuoteCalcInfo;